import { SaveLeadFormDraftParams } from '@plura/shared/types';
import { v4 as uuidv4 } from 'uuid';
import themes from './_themes';
import { generateCustomID } from '@plura/shared/utils';

// Export a function that generates fresh UUIDs each time it's called
const generateTestimonialFormTemplate = (): SaveLeadFormDraftParams => {
  const formId = uuidv4();
  const collectionId = generateCustomID(18)
  const workspaceId = uuidv4();

  // Generate new UUIDs for all blocks to ensure uniqueness
  const welcomeScreenId = uuidv4();
  const welcomeScreenBlockId = uuidv4();
  const contactInfo1Id = uuidv4();
  const contactInfo1BlockId = uuidv4();
  const contactInfo2Id = uuidv4();
  const contactInfo2BlockId = uuidv4();
  const longTextId = uuidv4();
  const longTextBlockId = uuidv4();
  const ratingId = uuidv4();
  const ratingBlockId = uuidv4();
  const emailId = uuidv4();
  const emailBlockId = uuidv4();
  const multipleChoiceId = uuidv4();
  const multipleChoiceBlockId = uuidv4();
  const endScreenId = uuidv4();
  const endScreenBlockId = uuidv4();

  // Generate new UUIDs for media
  const welcomeMediaId = uuidv4();
  const contactInfo2MediaId = uuidv4();
  const ratingMediaId = uuidv4();
  const emailMediaId = uuidv4();
  const endScreenMediaId = uuidv4();

  return {
    ...themes.spicedCocoaPeach,
    "collectionId": collectionId,
    "name": "Testimonial Form",
    "overview": "This is a form to collect leads",
    "about": "We're looking to connect with new leads",
    "tone": "Casual + Professional",
    "hideBuiltWithBadge": false,
    "closed": false,
    "closedMessage": "",
    "legalDisclaimer": false,
    "legalMessage": "",
    "notifications": false,
    "notificationEmail": "",
    "logoUrl": "https://s3.amazonaws.com/leadrr-prod-uploads/uploads/0d5b697e-e386-46ef-a2c7-34044737a773/GOLDLEAF-CO.png",
    "transitionType": "SLIDE_VERTICAL",
    "transitionSpeed": 500,
    "skipWelcomeScreen": false,
    "googleTagManager": "",
    "metaPixel": "",
    "assistantId": `asst_${collectionId}`,
    "fontSizeSetting": "MEDIUM",
    "customEndScreen": false,
    "hiddenFields": [],
    "journeyItems": [
      {
        "type": "WELCOME_SCREEN",
        "strictness": "COMMON",
        "contentAlignment": "LEFT",
        "mediaPosition": "SPLIT_RIGHT",
        "mobileMediaPosition": "MOBILE_INLINE_TOP",
        "id": welcomeScreenId,
        "blockId": welcomeScreenBlockId,
        "content": "Want to share your experience?",
        "manditory": false,
        "order": 0,
        "selectOptions": [],
        "multiSelect": null,
        "youtubeVideoURL": null,
        "internalName": null,
        "consentTitle": null,
        "minRange": null,
        "maxRange": null,
        "minLabel": null,
        "maxLabel": null,
        "secondaryContent": "We'd love to hear your story and celebrate your results.",
        "thirdContent": "Share Now",
        "forthContent": null,
        "icon": null,
        "additionalSettings": null,
        "targetBlockId": null,
        "endOnCompletion": false,
        "scoreValues": null,
        "responseTableVisible": null,
        "opacity": 100,
        "media": {
          "provider": "UNSPLASH",
          "id": welcomeMediaId,
          "type": "image",
          "name": "brown and black heart shaped paper",
          "link": "https://unsplash.com/photos/q--99IzY8Lw/download?ixid=M3w1Nzk2MDF8MHwxfHNlYXJjaHwzfHxzaGFwZXN8ZW58MHx8fHwxNzY0NDk0MzIzfDA",
          "workspaceId": workspaceId,
          "createdAt": new Date(),
          "updatedAt": new Date(),
          "author": "Lea L",
          "authorProfile": "https://unsplash.com/@leladesign",
          "downloadLink": "https://api.unsplash.com/photos/q--99IzY8Lw/download?ixid=M3w1Nzk2MDF8MHwxfHNlYXJjaHwzfHxzaGFwZXN8ZW58MHx8fHwxNzY0NDk0MzIzfDA"
        },
        "createdAt": new Date(),
        "updatedAt": new Date(),
        "formId": formId,
        "logicItems": [],
        "horizontalAlignment": false,
      },
      {
        "type": "CONTACT_INFO",
        "strictness": "COMMON",
        "contentAlignment": "LEFT",
        "mediaPosition": "INLINE_CENTER",
        "mobileMediaPosition": "MOBILE_POSTER_TOP",
        "id": contactInfo1Id,
        "blockId": contactInfo1BlockId,
        "content": "First things first,  what's your full name?",
        "manditory": true,
        "order": 1,
        "selectOptions": [],
        "multiSelect": null,
        "youtubeVideoURL": null,
        "internalName": null,
        "consentTitle": null,
        "minRange": null,
        "maxRange": null,
        "minLabel": null,
        "maxLabel": null,
        "secondaryContent": "We'll attribute your testimonial properly.",
        "thirdContent": null,
        "forthContent": null,
        "icon": null,
        "additionalSettings": {
          "first_name": {
            "required": false,
            "visible": true
          },
          "last_name": {
            "required": false,
            "visible": true
          },
          "email": {
            "required": false,
            "visible": false
          },
          "phone": {
            "required": false,
            "visible": false
          },
          "company": {
            "required": false,
            "visible": false
          }
        },
        "targetBlockId": null,
        "endOnCompletion": false,
        "scoreValues": null,
        "responseTableVisible": null,
        "opacity": null,
        "media": null,
        "createdAt": new Date(),
        "updatedAt": new Date(),
        "formId": formId,
        "logicItems": [],
        "horizontalAlignment": false,
      },
      {
        "type": "CONTACT_INFO",
        "strictness": "COMMON",
        "contentAlignment": "RIGHT",
        "mediaPosition": "SPLIT_LEFT",
        "mobileMediaPosition": "MOBILE_INLINE_TOP",
        "id": contactInfo2Id,
        "blockId": contactInfo2BlockId,
        "content": "What's your company and role?",
        "manditory": true,
        "order": 2,
        "selectOptions": [],
        "multiSelect": null,
        "youtubeVideoURL": null,
        "internalName": null,
        "consentTitle": null,
        "minRange": null,
        "maxRange": null,
        "minLabel": null,
        "maxLabel": null,
        "secondaryContent": "If you freelance or run your own business, feel free to list that too.",
        "thirdContent": null,
        "forthContent": null,
        "icon": null,
        "additionalSettings": {
          "first_name": {
            "required": false,
            "visible": false
          },
          "last_name": {
            "required": false,
            "visible": false
          },
          "email": {
            "required": false,
            "visible": false
          },
          "phone": {
            "required": false,
            "visible": false
          },
          "company": {
            "required": false,
            "visible": true
          }
        },
        "targetBlockId": null,
        "endOnCompletion": false,
        "scoreValues": null,
        "responseTableVisible": null,
        "opacity": 100,
        "media": {
          "provider": "UNSPLASH",
          "id": contactInfo2MediaId,
          "type": "image",
          "name": "white paper on white table",
          "link": "https://unsplash.com/photos/4N6qT784t3A/download?ixid=M3w1Nzk2MDF8MHwxfHNlYXJjaHwxMnx8c2hhcGVzfGVufDB8fHx8MTc2NDQ5NDMyM3ww",
          "workspaceId": workspaceId,
          "createdAt": new Date(),
          "updatedAt": new Date(),
          "author": "Lea L",
          "authorProfile": "https://unsplash.com/@leladesign",
          "downloadLink": "https://api.unsplash.com/photos/4N6qT784t3A/download?ixid=M3w1Nzk2MDF8MHwxfHNlYXJjaHwxMnx8c2hhcGVzfGVufDB8fHx8MTc2NDQ5NDMyM3ww"
        },
        "createdAt": new Date(),
        "updatedAt": new Date(),
        "formId": formId,
        "logicItems": [],
        "horizontalAlignment": false,
      },
      {
        "type": "LONG_TEXT",
        "strictness": "COMMON",
        "contentAlignment": "LEFT",
        "mediaPosition": "INLINE_CENTER",
        "mobileMediaPosition": "MOBILE_POSTER_TOP",
        "id": longTextId,
        "blockId": longTextBlockId,
        "content": `Amazing, {{${contactInfo1BlockId}__first_name}}! Tell us about your experience.`,
        "manditory": true,
        "order": 3,
        "selectOptions": [],
        "multiSelect": null,
        "youtubeVideoURL": null,
        "internalName": null,
        "consentTitle": null,
        "minRange": null,
        "maxRange": null,
        "minLabel": null,
        "maxLabel": null,
        "secondaryContent": "What stood out while working with us? Share as much or as little as you'd like.",
        "thirdContent": null,
        "forthContent": null,
        "icon": null,
        "additionalSettings": null,
        "targetBlockId": null,
        "endOnCompletion": false,
        "scoreValues": null,
        "responseTableVisible": null,
        "opacity": null,
        "media": null,
        "createdAt": new Date(),
        "updatedAt": new Date(),
        "formId": formId,
        "logicItems": [],
        "horizontalAlignment": false,
      },
      {
        "type": "RATING",
        "strictness": "COMMON",
        "contentAlignment": "LEFT",
        "mediaPosition": "DETATCHED_RIGHT",
        "mobileMediaPosition": "MOBILE_INLINE_TOP",
        "id": ratingId,
        "blockId": ratingBlockId,
        "content": "How would you rate your overall experience?",
        "manditory": true,
        "order": 4,
        "selectOptions": [],
        "multiSelect": null,
        "youtubeVideoURL": null,
        "internalName": null,
        "consentTitle": null,
        "minRange": 5,
        "maxRange": null,
        "minLabel": null,
        "maxLabel": null,
        "secondaryContent": "Your honest rating helps us improve.",
        "thirdContent": null,
        "forthContent": null,
        "icon": "star",
        "additionalSettings": null,
        "targetBlockId": null,
        "endOnCompletion": false,
        "scoreValues": null,
        "responseTableVisible": null,
        "opacity": null,
        "media": {
          "provider": "UNSPLASH",
          "id": ratingMediaId,
          "type": "image",
          "name": "2 brown egg on white egg tray",
          "link": "https://unsplash.com/photos/oAJnyZkNEs8/download?ixid=M3w1Nzk2MDF8MHwxfHNlYXJjaHwxN3x8c2hhcGVzfGVufDB8fHx8MTc2NDQ5NDMyM3ww",
          "workspaceId": workspaceId,
          "createdAt": new Date(),
          "updatedAt": new Date(),
          "author": "Lea L",
          "authorProfile": "https://unsplash.com/@leladesign",
          "downloadLink": "https://api.unsplash.com/photos/oAJnyZkNEs8/download?ixid=M3w1Nzk2MDF8MHwxfHNlYXJjaHwxN3x8c2hhcGVzfGVufDB8fHx8MTc2NDQ5NDMyM3ww"
        },
        "createdAt": new Date(),
        "updatedAt": new Date(),
        "formId": formId,
        "logicItems": [],
        "horizontalAlignment": false,
      },
      {
        "type": "EMAIL",
        "strictness": "COMMON",
        "contentAlignment": "LEFT",
        "mediaPosition": "DETATCHED_RIGHT",
        "mobileMediaPosition": "MOBILE_INLINE_CENTER",
        "id": emailId,
        "blockId": emailBlockId,
        "content": "What's the best email to reach you at?",
        "manditory": false,
        "order": 5,
        "selectOptions": [],
        "multiSelect": null,
        "youtubeVideoURL": null,
        "internalName": null,
        "consentTitle": null,
        "minRange": null,
        "maxRange": null,
        "minLabel": null,
        "maxLabel": null,
        "secondaryContent": "As a thank-you, we'll send something special your way.",
        "thirdContent": null,
        "forthContent": null,
        "icon": null,
        "additionalSettings": null,
        "targetBlockId": null,
        "endOnCompletion": false,
        "scoreValues": null,
        "responseTableVisible": null,
        "opacity": null,
        "media": {
          "provider": "UNSPLASH",
          "id": emailMediaId,
          "type": "image",
          "name": "brown and black heart shaped paper",
          "link": "https://unsplash.com/photos/q--99IzY8Lw/download?ixid=M3w1Nzk2MDF8MHwxfHNlYXJjaHwzfHxzaGFwZXN8ZW58MHx8fHwxNzY0NDk0MzIzfDA",
          "workspaceId": workspaceId,
          "createdAt": new Date(),
          "updatedAt": new Date(),
          "author": "Lea L",
          "authorProfile": "https://unsplash.com/@leladesign",
          "downloadLink": "https://api.unsplash.com/photos/q--99IzY8Lw/download?ixid=M3w1Nzk2MDF8MHwxfHNlYXJjaHwzfHxzaGFwZXN8ZW58MHx8fHwxNzY0NDk0MzIzfDA"
        },
        "createdAt": new Date(),
        "updatedAt": new Date(),
        "formId": formId,
        "logicItems": [],
        "horizontalAlignment": false,
      },
      {
        "type": "MULTIPLE_CHOICE",
        "strictness": "COMMON",
        "contentAlignment": "LEFT",
        "mediaPosition": "INLINE_CENTER",
        "mobileMediaPosition": "MOBILE_POSTER_TOP",
        "id": multipleChoiceId,
        "blockId": multipleChoiceBlockId,
        "content": "Can we feature your testimonial publicly?",
        "manditory": true,
        "order": 6,
        "selectOptions": [
          {
            "id": "yes",
            "order": 0,
            "value": "Yes, feel free to use it"
          },
          {
            "id": "no",
            "order": 1,
            "value": "I'd prefer to keep it private"
          }
        ],
        "multiSelect": null,
        "youtubeVideoURL": null,
        "internalName": null,
        "consentTitle": null,
        "minRange": null,
        "maxRange": null,
        "minLabel": null,
        "maxLabel": null,
        "secondaryContent": null,
        "thirdContent": null,
        "forthContent": null,
        "icon": null,
        "additionalSettings": null,
        "targetBlockId": null,
        "endOnCompletion": false,
        "scoreValues": null,
        "responseTableVisible": null,
        "opacity": null,
        "media": null,
        "createdAt": new Date(),
        "updatedAt": new Date(),
        "formId": formId,
        "logicItems": [],
        "horizontalAlignment": false,
      },
      {
        "type": "END_SCREEN",
        "strictness": "COMMON",
        "contentAlignment": "LEFT",
        "mediaPosition": "FULL",
        "mobileMediaPosition": "MOBILE_FULL",
        "id": endScreenId,
        "blockId": endScreenBlockId,
        "content": `Thanks so much, {{${contactInfo1BlockId}__first_name}}!`,
        "manditory": false,
        "order": 7,
        "selectOptions": [],
        "multiSelect": null,
        "youtubeVideoURL": null,
        "internalName": null,
        "consentTitle": null,
        "minRange": null,
        "maxRange": null,
        "minLabel": null,
        "maxLabel": null,
        "secondaryContent": "We appreciate you taking the time to share your experience.",
        "thirdContent": "Visit Website",
        "forthContent": "https://www.formsuite.co",
        "icon": null,
        "additionalSettings": null,
        "targetBlockId": null,
        "endOnCompletion": true,
        "scoreValues": null,
        "responseTableVisible": null,
        "opacity": 39,
        "media": {
          "provider": "UNSPLASH",
          "id": endScreenMediaId,
          "type": "image",
          "name": "2 brown egg on white egg tray",
          "link": "https://unsplash.com/photos/oAJnyZkNEs8/download?ixid=M3w1Nzk2MDF8MHwxfHNlYXJjaHwxN3x8c2hhcGVzfGVufDB8fHx8MTc2NDQ5NDMyM3ww",
          "workspaceId": workspaceId,
          "createdAt": new Date(),
          "updatedAt": new Date(),
          "author": "Lea L",
          "authorProfile": "https://unsplash.com/@leladesign",
          "downloadLink": "https://api.unsplash.com/photos/oAJnyZkNEs8/download?ixid=M3w1Nzk2MDF8MHwxfHNlYXJjaHwxN3x8c2hhcGVzfGVufDB8fHx8MTc2NDQ5NDMyM3ww"
        },
        "createdAt": new Date(),
        "updatedAt": new Date(),
        "formId": formId,
        "logicItems": [],
        "horizontalAlignment": false,
      }
    ],
    "snippets": [],
    "metaTitle": "Testimonial Form",
    "gdprSetting": "NEVER",
    "gdprRequired": false,
    "consentMessageTitle": "I consent to the collection of my personal data"
  };
}

export default generateTestimonialFormTemplate;